<template>
  <v-container v-if="active">
    <v-dialog v-model="active" width="700" transition="dialog-bottom-transition">
      <v-card>
        <v-overlay :value="saving">
          <v-progress-circular indeterminate size="64" />
          <br />Updating Check-in
        </v-overlay>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Edit Check-in</v-toolbar-title>
          <v-spacer />
        </v-toolbar>
        <v-card-text>
          <v-form class="mt-2">
            <v-row>
              <v-col cols="6">
                <v-select v-model="assessment.type" label="Check-in type" required :items="typeOptions"> </v-select>
              </v-col>
              <v-col cols="6">
                <v-menu ref="menu" v-model="menu" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="assessment.assessmentDateFormatted"
                      label="Check-in Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker v-model="assessment.assessmentDateFormatted" no-title scrollable />
                </v-menu>
              </v-col>
            </v-row>
            <h2>Anthropometric</h2>
            <v-row class="anthropometric py-2">
              <v-col cols="4">
                <v-text-field v-model="assessment.weight" label="Weight (kg)" />
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="assessment.abdomen" label="Abdomen (cm)" />
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="assessment.chest" label="Chest (cm)" />
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="assessment.hip" label="Hip (cm)" />
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="assessment.quad" label="Quad (cm)" />
              </v-col>
            </v-row>
            <h2 class="mt-4">Photos</h2>
            <div class="photos">
              <v-row class="py-2">
                <v-col cols="4">
                  <div class="d-flex flex-column">
                    <v-file-input
                      show-size
                      label="Front Image"
                      accept="image/*"
                      @change="uploadFrontImage"
                      class="pt-0"
                    />
                    <div v-if="assessment.imgFront">
                      <span>Current: </span><br />
                      <img :src="assessment.imgFront" height="200" />
                    </div>
                  </div>
                </v-col>
                <v-col cols="4">
                  <div class="d-flex flex-column">
                    <v-file-input
                      show-size
                      label="Back Image"
                      accept="image/*"
                      @change="uploadBackImage"
                      class="pt-0"
                    />
                    <div v-if="assessment.imgBack">
                      <span>Current:</span><br />
                      <img :src="assessment.imgBack" height="200" />
                    </div>
                  </div>
                </v-col>
                <v-col cols="4">
                  <div class="d-flex flex-column">
                    <v-file-input
                      show-size
                      label="Side Image"
                      accept="image/*"
                      @change="uploadSideImage"
                      class="pt-0"
                    />
                    <div v-if="assessment.imgSide">
                      <span>Current:</span><br />
                      <img :src="assessment.imgSide" height="200" />
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
            <h2 class="mt-4">Fitness</h2>
            <v-row class="fitness py-2">
              <v-col cols="4">
                <v-text-field
                  v-model="assessment.oneMileTime"
                  type="time"
                  step="1"
                  label="1 mile/1.6km"
                  hint="HH:mm:ss"
                  @change="updateOneMile"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="assessment.pushUps" label="2min Push-ups" />
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="assessment.sitUps" label="1min Sit-ups" />
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="assessment.burpeeChirpee" label="1min Burpee/Chirpee" />
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="assessment.elbowPlank" label="Elbow Plank (secs)" />
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="assessment.squat" label="Squat Hold/Wall Squat (secs)" />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="submit()">Save</v-btn>
          <v-spacer />
          <v-btn v-if="assessment.type == 'COACHING'" color="error" @click="deleteCheckIn()">Delete Check-in</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { UPDATE_ASSESSMENT_QUERY, DELETE_CHECK_IN_MUTATION } from "@/graphql/mutations/checkin";

export default {
  name: "EditAssessmentForm",
  data() {
    return {
      saving: false,
      active: false,
      menu: false,
      assessment: {},
      typeOptions: [
        { value: "COACHING", text: "Coaching" },
        { value: "USER", text: "User generated" },
      ],
      images: {
        back: null,
        front: null,
        side: null,
      },
    };
  },
  mounted() {
    this.resetData();
  },
  methods: {
    updateOneMile(time) {
      let timeSplit = time.split(":");
      var hours = timeSplit[0];
      var minutes = timeSplit[1];
      var seconds = timeSplit.length > 2 ? timeSplit[2] : 0;

      this.assessment.oneMile = parseInt(hours) * 60 * 60 + parseInt(minutes) * 60 + parseInt(seconds);
    },
    getId(base64string) {
      let decoded = atob(base64string).split(":");
      if (decoded[1]) return decoded[1];
      return "";
    },
    resetData() {
      this.assessment = {
        id: null,
        encodedId: null,
        abdomen: null,
        assessmentDate: null,
        assessmentDateFormatted: null,
        chest: null,
        hip: null,
        quad: null,
        imgBack: null,
        imgFront: null,
        imgSide: null,
        oneMileTime: null,
        oneMile: null,
        pushUps: null,
        sitUps: null,
        burpeeChirpee: null,
        elbowPlank: null,
        squat: null,
      };
      this.images = {
        imgBack: null,
        imgFront: null,
        imgSide: null,
      };
    },
    setAssessment(assessment) {
      this.resetData();
      let fields = [
        "id",
        "abdomen",
        "weight",
        "assessmentDate",
        "chest",
        "hip",
        "quad",
        "imgBack",
        "imgFront",
        "imgSide",
        "oneMileTime",
        "oneMile",
        "pushUps",
        "sitUps",
        "burpeeChirpee",
        "elbowPlank",
        "squat",
        "type",
      ];

      fields.forEach((field) => {
        if (field == "id") {
          this.assessment["encodedId"] = assessment[field];
          this.assessment[field] = this.getId(assessment[field]);
        } else {
          this.assessment[field] = assessment[field];
        }
      });

      if (assessment["assessmentDate"] != null) {
        let moment = this.$moment(assessment["assessmentDate"]);
        this.assessment.assessmentDateFormatted = moment.format("YYYY-MM-DD");
      }
    },
    uploadFrontImage(file) {
      this.images.imgFront = file;
    },
    uploadBackImage(file) {
      this.images.imgBack = file;
    },
    uploadSideImage(file) {
      this.images.imgSide = file;
    },
    open(assessment) {
      this.active = true;
      this.setAssessment(assessment);
    },
    close() {
      this.active = false;
    },
    deleteCheckIn() {
      let confirmed = confirm("Are you sure you want to delete this note?");
      if (!confirmed) return;
      this.saving = true;
      this.$apollo
        .mutate({
          mutation: DELETE_CHECK_IN_MUTATION,
          variables: {
            id: this.assessment["encodedId"],
          },
          refetchQueries: ["userCheckIns"],
        })
        .then((result) => {
          this.$toasted.success("Assessment Deleted", {
            icon: "arm-flex",
            duration: 2000,
            position: "bottom-center",
          });
          this.saving = false;
          this.close();
        })
        .catch((error) => {});
    },
    submit() {
      this.saving = true;

      let data = JSON.parse(JSON.stringify(this.assessment));
      ["imgBack", "imgFront", "imgSide"].forEach((field) => {
        data[field] = this.images[field];
      });
      delete data.assessmentDateFormatted;
      delete data.oneMileTime;
      delete data.encodedId;

      let assessmentDate = this.$moment.utc(this.assessment.assessmentDateFormatted, "YYYY-MM-DD");
      data.assessmentDate = assessmentDate.toISOString();

      this.$apollo
        .mutate({
          mutation: UPDATE_ASSESSMENT_QUERY,
          variables: { input: data },
          refetchQueries: ["userCheckIns"],
        })
        .then((result) => {
          this.saving = false;
          this.close();
          this.$toasted.success("Assessment Updated", {
            icon: "arm-flex",
            duration: 2000,
            position: "bottom-center",
          });
        })
        .catch((error) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.row.anthropometric .col,
.row.fitness .col {
  padding: 0 12px;
}
</style>
